import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createPODisclaimerLabel.createPODisclaimerLabelForm`

export default defineMessages({
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: 'Label description',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Label description',
  },
  descriptionRequiredError: {
    id: `${scope}.descriptionRequiredError`,
    defaultMessage: 'Label description is required',
  },
  contentLabel: {
    id: `${scope}.contentLabel`,
    defaultMessage: 'Label content',
  },
  contentPlaceholder: {
    id: `${scope}.contentPlaceholder`,
    defaultMessage: 'Label content',
  },
  contentRequiredError: {
    id: `${scope}.contentRequiredError`,
    defaultMessage: 'Label content is required',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
})
